import { languageService } from "../../../../Language/language.service";
import { arrayToSelectOptions } from "../../../../utils/arrayToSelectOptions";

const dateTimeFormat = "MM-DD-yy HH:mm";
const timeFormat = "HH:mm";

export const hosEntryFormSchema = {
  title: languageService("Add Duty Time"),
  id: "HOSEntrySchema",
  returnOnlyEnabledFields: false,
  stateTitle: {
    create: languageService("Add Duty Time"),
    edit: languageService("Update Duty Time"),
    partialEdit: languageService("Update Duty Location/Activity"),
    delete: `${languageService("Are you sure you want to delete the following entry?")}`,
  },
  sections: [
    {
      id: "typeSelectionSection",
      disabledStates: ["delete"],
      fields: [
        {
          id: "dutyType", // required
          type: "select", // required
          labelValue: languageService("Duty Type"),
          selectOptions: [],
          required: true,
          disabledStates: ["edit", "partialEdit"],
          updateFieldOptionsOnCertainValue: [
            {
              targetSecId: "typeSelectionSection",
              targetFieldId: "serviceType",
              getFieldOptionsCallback: "getServiceTypeOptionsBasedOnDutyType",
              resetOtherFields: [
                {
                  secId: "typeSelectionSection",
                  fieldId: "activityTypeCode",
                },
              ],
            },
          ],
          showFieldsOnCertainValue: [
            {
              values: ["Interrupted Rest"],
              targetIds: [
                "serviceType",
                "activityTypeCode",
                "comments",
                "startLocCode",
                "endLocCode",
                "startDate",
                "endDate",
                "addHosLocation",
              ],
              inverse: true,
            },
            {
              targetIds: ["pointDate"],
              values: ["Interrupted Rest"],
            },
            {
              values: ["Other", "Interrupted Rest"],
              targetIds: ["activityTypeCode"],
              inverse: true,
            },
          ],
          col: 6,
        },
        {
          id: "serviceType", // required
          type: "select", // required
          labelValue: languageService("Service Type"),
          selectOptions: [],
          required: true,
          updateFieldOptionsOnCertainValue: [
            {
              targetSecId: "typeSelectionSection",
              targetFieldId: "activityTypeCode",
              getFieldOptionsCallback: "getActivityTypeOptionsBasedOnServiceType",
              resetFields: [
                {
                  secId: "typeSelectionSection",
                  fieldId: "activityTypeCode",
                },
              ],
            },
          ],
          requiredValidationCertainValues: [
            {
              targetFieldId: "comments",
              targetSecId: "typeSelectionSection",
              requiredOptionValues: ["Commingled Service"],
            },
          ],
          //  showFieldsOnCertainValue: [{ targetIds: ["comments"], values: ["Commingled Service"] }],
          disabledStates: ["edit", "partialEdit"],
          col: 6,
        },
        {
          id: "activityTypeCode", // required
          type: "select", // required
          labelValue: languageService("Activity Type"),
          selectOptions: [],
          col: 6,
        },
        {
          id: "comments", // required
          type: "textarea", // required
          labelValue: languageService("Comments"),
          col: 6,
        },
        {
          id: "pointDate",
          type: "dateTime",
          labelValue: languageService("Time"),
          format: dateTimeFormat,
          timeFormat: timeFormat,
          disabledStates: ["delete", "partialEdit"],
          required: true,
          timeIntervals: 5,
          col: 6,
          allowKeyboardInput: true,
        },
      ],
    },
    {
      id: "serviceTypeSelectionSection",
      disabledStates: ["delete"],
      fields: [],
    },
    {
      id: "activityTypeSection",
      disabledStates: ["delete"],
      fields: [],
    },
    {
      id: "dateAndTimeEntrySection",
      disabledStates: ["delete", "partialEdit"],
      fields: [
        {
          id: "startDate",
          type: "dateTime",
          labelValue: languageService("Start Time"),
          format: dateTimeFormat,
          timeFormat: timeFormat,
          timeIntervals: 5,
          allowKeyboardInput: true,
          col: 6,
          required: true,
        },
        {
          id: "endDate",
          type: "dateTime",
          labelValue: languageService("End Time"),
          format: dateTimeFormat,
          timeFormat: timeFormat,
          timeIntervals: 5,
          allowKeyboardInput: true,
          col: 6,
          required: true,
        },
      ],
    },
    {
      id: "locationSelectionSection",
      disabledStates: ["delete", "partialEdit"],
      fields: [
        {
          id: "startLocCode", // required
          type: "select", // required
          labelValue: languageService("Start Location"),
          selectOptions: [],
          hidden: true,
          col: 6,
        },
        {
          id: "endLocCode", // required
          type: "select", // required
          labelValue: languageService("End Location"),
          selectOptions: [],
          hidden: true,
          col: 6,
        },
      ],
    },
    {
      id: "addHosLocationEntrySection",

      fields: [
        {
          id: "addHosLocation",
          labelValue: languageService("Add Location..."),
          type: "button",
          callback: "addHosEntryLocation",
          hiddenStates: ["edit", "delete", "partialEdit"],
          col: 6,
        },
      ],
    },

    {
      id: "footerActionsSection",
      fields: [
        {
          id: "addHosEntry",
          type: "button",
          labelValue: languageService("Add"),
          action: "submit",
          callback: "addHosEntry",
          position: "footer",
          hiddenStates: ["edit", "delete", "partialEdit"],
          col: 6,
        },
        {
          id: "confirmDeleteHosEntry",
          type: "button",
          labelValue: languageService("Confirm"),
          action: "submit",
          callback: "confirmDeleteHosEntry",
          position: "footer",
          hiddenStates: ["create", "edit", "partialEdit"],
          col: 6,
        },
        {
          id: "updateHosEntry",
          type: "button",
          labelValue: languageService("Update"),
          action: "submit",
          callback: "updateHosEntry",
          position: "footer",
          hiddenStates: ["create", "delete"],
          col: 6,
        },
        {
          id: "cancelEntryDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/MyHoursOfService/schemas/hosEntryFormSchema.js